import { jsx as m } from "react/jsx-runtime";
import _ from "react";
import { clsx as f } from "../../utils/clsx.js";
import '../../assets/Badge.css';const l = "_root_11j4y_1", n = "_primary_11j4y_16", o = {
  root: l,
  default: "_default_11j4y_11",
  primary: n
}, y = _.forwardRef(function(r, t) {
  const {
    color: a = "default",
    children: s,
    className: e
  } = r, c = f(o.root, e, o[a]);
  return /* @__PURE__ */ m("div", { ref: t, className: c, children: s });
});
export {
  y as Badge
};
